// Field ids (T7): "fld_" + 8 random [a-z0-9], minted by the admin and stable
// for the life of a form. The server accepts 4–24 characters after "fld_".

export const FIELD_ID_RE = /^fld_[a-z0-9]{4,24}$/;

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
const ID_LENGTH = 8;
// Largest multiple of 36 below 256: bytes at or above it are redrawn so
// every character is equally likely.
const BYTE_LIMIT = 252;

const randomBytes = (n) => {
  const cryptoApi =
    typeof window !== 'undefined' && (window.crypto || window.msCrypto);
  const bytes = new Uint8Array(n);
  if (cryptoApi && cryptoApi.getRandomValues) {
    cryptoApi.getRandomValues(bytes);
  } else {
    for (let i = 0; i < n; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
};

export const newFieldId = () => {
  let out = '';
  while (out.length < ID_LENGTH) {
    const bytes = randomBytes(ID_LENGTH * 2);
    for (let i = 0; i < bytes.length && out.length < ID_LENGTH; i += 1) {
      if (bytes[i] < BYTE_LIMIT) out += ALPHABET[bytes[i] % ALPHABET.length];
    }
  }
  return `fld_${out}`;
};
